import React from 'react';
import PrivateRoute from '../core/components/private-route';

import WelcomePage from '../tester/pages/welcome';
import ThankYouPage from '../tester/pages/thank-you';
import InstructionsTester from '../tester/pages/instructions-tester';
import TreeTestTask from '../tester/pages/tree-test-task/index';
import CardSort from '../tester/pages/card-sort';

const RoutesPreview = [
  <PrivateRoute exact path="/welcome" component={WelcomePage} key="welcome-key" isPreview />,
  <PrivateRoute exact path="/thank-you" component={ThankYouPage} key="thank-you-key" isPreview />,
  <PrivateRoute exact path="/card-sort" component={CardSort} key="card-sort-key" isPreview />,
  <PrivateRoute exact path="/instructions-tester" component={InstructionsTester} key="instructions-tester-key" isPreview />,
  <PrivateRoute exact path="/tree-test-task" component={TreeTestTask} key="tree-test-task-key" isPreview />,
];

export default RoutesPreview;
